<template>
	<v-card ref="root" class="pa-0 d-flex" height="100%">
		<div class="w-80 h-100" :class="{'pr-1': panel.xl}">
			<TimeBox :params="params" />
		</div>
		<div class="w-20 py-1" :class="{'v-row pr-3': panel.xxl}">
			<div
				:class="{
					'pt-0': !panel.xxl,
					'v-col-6 py-3 pr-1 h-100': panel.xxl,
					'pb-2': panel.xl && !panel.xxl,
					'pb-1': !panel.xl,
					'h-30': !panel.xxl
				}"
			>
				<MicrophoneButton />
			</div>
			<div
				:class="{
					'pb-0': !panel.xxl,
					'v-col-6 py-3 pl-1 h-100': panel.xxl,
					'pt-2': panel.xl && !panel.xxl,
					'pt-1': !panel.xl,
					'h-70': !panel.xxl
				}"
			>
				<DumpButton />
			</div>
		</div>
	</v-card>
</template>

<script>
import DumpButton from "@/components/DumpButton.vue";
import MicrophoneButton from "@/components/MicrophoneButton.vue";
import TimeBox from "@/components/TimeBox.vue";

const PANEL_BREAKPOINTS = {lg: 480, xl: 640, xxl: 960};

// Smallest group height (tab header included) that still fits the content of each layout.
const PANEL_MIN_HEIGHT = {wide: 340, narrow: 470};
const PANEL_MIN_WIDTH = 420;

export default {
	name: "GoLive",

	components: {
		DumpButton,
		MicrophoneButton,
		TimeBox
	},

	// Layout breakpoints follow the width of the panel hosting this module, not the browser window.
	provide() {
		return {goLivePanel: this.panel};
	},

	props: ["params"],

	data() {
		return {
			panel: {lg: false, xl: false, xxl: false}
		};
	},

	watch: {
		"panel.xl"() {
			this.updateMinSize();
		}
	},

	mounted() {
		// Constraints belong to the group, so reapply them whenever the panel is moved into another one.
		this.groupChangeDisposable = this.params?.api?.onDidGroupChange(() => {
			this.updateMinSize();
			this.$nextTick(this.fitNewGroup);
		});

		this.resizeObserver = new ResizeObserver(entries => {
			this.updatePanel(entries[0].contentRect.width);
		});
		const el = this.$refs.root?.$el;
		if (el instanceof Element) {
			this.resizeObserver.observe(el);
			// Measure before constraining, otherwise the default "narrow" flag forces a needlessly tall group.
			this.updatePanel(el.clientWidth);
		}
		this.updateMinSize();
	},

	beforeUnmount() {
		this.resizeObserver?.disconnect();
		this.groupChangeDisposable?.dispose();
	},

	methods: {
		minHeightFor(width) {
			return width >= PANEL_BREAKPOINTS.xl ? PANEL_MIN_HEIGHT.wide : PANEL_MIN_HEIGHT.narrow;
		},

		updateMinSize() {
			this.params?.api?.group?.api?.setConstraints({
				minimumWidth: PANEL_MIN_WIDTH,
				minimumHeight: this.panel.xl ? PANEL_MIN_HEIGHT.wide : PANEL_MIN_HEIGHT.narrow
			});
		},

		// Dockview gives a freshly created group a share of the available space (often half),
		// so when the panel lands in a new grid group, shrink it to its content height.
		fitNewGroup() {
			const api = this.params?.api;
			const group = api?.group;
			group.api.setSize({height: this.minHeightFor(group.api.width)});
		},

		updatePanel(width) {
			this.panel.lg = width >= PANEL_BREAKPOINTS.lg;
			this.panel.xl = width >= PANEL_BREAKPOINTS.xl;
			this.panel.xxl = width >= PANEL_BREAKPOINTS.xxl;
		}
	}
};
</script>
